export enum UploadType {
    S3 = 1,
    LocalUpload = 2,
    ServerFileUpload = 3,
}
